import { PayloadAction } from "@reduxjs/toolkit";
import { eventChannel } from "redux-saga";
import { put, take, takeEvery } from "redux-saga/effects";

import { chatNotificationAction } from "../redux/actions";
import { setChatNotification } from "../redux/reducer/chat.reducer";
import { GetNotificationActionData } from "../type/queries.types";

function* chatNotificationSaga(data: PayloadAction<GetNotificationActionData>): any {
  const getOneUnseenRoomQuery = data.payload.getOneUnseenRoomQuery;

  const unseenRoomChannel = eventChannel((emit) =>
    getOneUnseenRoomQuery().onSnapshot(emit, (ex) => {
      console.log(ex.message);
    })
  );

  while (true) {
    try {
      const snapshot = yield take(unseenRoomChannel);
      if (!snapshot.empty) yield put(setChatNotification(snapshot.docs[0].data()));
      else yield put(setChatNotification(undefined));
    } catch (ex: any) {
      yield put(setChatNotification(undefined));
      console.log(ex.message);
    }
  }
}

export default function* watchChatNotifications() {
  yield takeEvery(chatNotificationAction.toString(), chatNotificationSaga);
}
